import { PageWrapper } from '../../components/PageWrapper';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { PHONE_PASSWORD_LOGIN, PHONE_PASSWORD_CREATE_CONFIRM } from '../../constants/routes';
import { formatPhoneNumber } from '../../utils/phoneNumber';
import OtpInput from 'react18-input-otp';
import { BeatLoader } from 'react-spinners';
export const PhonePasswordCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { phoneNumber, isForgotPassword, isVerified } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');

  // Redirect if no phone number or not verified
  useEffect(() => {
    if (!phoneNumber || !isVerified) {
      navigate(PHONE_PASSWORD_LOGIN);
    }
  }, [phoneNumber, isVerified, navigate]);

  // Auto-navigate to confirmation when password is complete
  useEffect(() => {
    if (password.length === 6) {
      setTimeout(() => {
        navigate(PHONE_PASSWORD_CREATE_CONFIRM, {
          state: {
            phoneNumber,
            isForgotPassword,
            isVerified,
            isNewUser: location.state?.isNewUser ?? false, // Explicitly pass isNewUser
            password,
          },
        });
      }, 300);
    }
  }, [password, phoneNumber, isForgotPassword, isVerified, location.state?.isNewUser, navigate]);

  return (
    <PageWrapper
      title={isForgotPassword ? "🔑 Créer un nouveau mot de passe" : "🔑 Crée ton mot de passe"}
      onGoBack={() => navigate(PHONE_PASSWORD_LOGIN, { state: { phoneNumber } })}
    >
      <div className="flex flex-col items-center justify-center gap-6">

        {/* Password input */}
        <div className="w-full flex justify-center">
          {loading ? (
            <BeatLoader color="#183153" size={20} />
          ) : (
            <OtpInput
            value={password}
            onChange={setPassword}
            numInputs={6}
            isInputNum={true}
            isDisabled={loading}
            shouldAutoFocus={true}
            inputStyle="password-input"
            isInputSecure={true}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            separator={<span className="otp-separator" />}
            containerStyle="otp-container"
          />
          )}
        </div>

        {/* Instructions */}
        <p className="text-gray-500 text-lg mt-2 text-center">
          Entre 6 chiffres pour ton mot de passe
        </p>
      </div>
    </PageWrapper>
  );
};

